import {Component, Input, OnInit, OnChanges, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-duplicate',
  templateUrl: './duplicate.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./duplicate.component.scss']
})
export class DuplicateComponent implements OnInit, OnChanges {
  @Input('name') name: string;
  @Input('duplicates') duplicates: Duplicate[] = [];
  @Input('message') message: string;

  public hideMessage = false;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('value changed:', changes);
  }
}

export interface Duplicate {
  name: string;
  url: string;
}
